export const DEFAULT_EMPTY_NOTE = {
  id: undefined,
  comment_type: undefined,
  private: false,
  comment: "",
};
